export default __webpack_public_path__ + "static/CSC_Logo-e5a930a841fc663c2ca794f74a54de52.png";